/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 ~ Copyright 2018 Adobe Systems Incorporated
 ~
 ~ Licensed under the Apache License, Version 2.0 (the "License");
 ~ you may not use this file except in compliance with the License.
 ~ You may obtain a copy of the License at
 ~
 ~     http://www.apache.org/licenses/LICENSE-2.0
 ~
 ~ Unless required by applicable law or agreed to in writing, software
 ~ distributed under the License is distributed on an "AS IS" BASIS,
 ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 ~ See the License for the specific language governing permissions and
 ~ limitations under the License.
 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
import withAemIntegration from "../../../withAemIntegration";
import loadable from "../../../utils/loadable";
const Component = loadable(() =>
  import(
    "@lexus.com/ui/dist/_nextgen/applications/MyLexus/components/ManageGarageWizard/index.impl"
  )
);

const EditConfig = {
  emptyLabel: "Vehicle Management Modal",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const Render = (props) => {
  return <Component {...props} />;
};

export default withAemIntegration(
  "lexus/components/content/my-lexus/vehicle-management-modal"
)(Render, EditConfig);
